import fetch from 'isomorphic-fetch';
import { applyMiddleware, combineReducers, createStore as createReduxStore } from 'redux';
import { autoRehydrate } from 'redux-persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reducer as onionForm } from 'onion-form';
import { promiseMiddleware } from './midlewares/promiseMiddleware';
import injectDependencies from './midlewares/injectDependencies';
import healthCheck from './healthCheck/reducer';

const createStore = (initialState = new Map({}), { middlewares = [] }) => {
  const reducers = {
    onionForm,
    healthCheck,
  };

  const customMiddlewares = applyMiddleware(
    injectDependencies({ fetch }),
    promiseMiddleware,
    ...middlewares,
  );

  const allMiddlewares = composeWithDevTools(customMiddlewares, autoRehydrate());

  return createReduxStore(
    combineReducers(reducers),
    initialState,
    allMiddlewares,
  );
};

export default createStore;
